//#region src/entities/prompt/constants.ts
var MAX_PROMPT_SIZE = 1e4;
//#endregion
export { MAX_PROMPT_SIZE };

//# sourceMappingURL=constants.js.map